import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function SEOContent() {
  return (
    <section className="section" style={{ background: 'var(--bg)', borderTop: '1px solid var(--border)' }}>
      <div className="wrap">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: .5 }}
          style={{ maxWidth: 860 }}
        >
          <h2 className="h2" style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
            Kocaeli <span style={{ color: 'var(--blue)' }}>Lastik Yol Yardım</span> — En Yakın Lastikçi 7/24
          </h2>

          <div className="seo-text" style={{ color: 'var(--text2)', fontSize: '.9rem', lineHeight: 1.85 }}>
            <p>
              <strong>Kocaeli lastik yol yardım</strong> hizmeti arıyorsanız doğru yerdesiniz. 7/24 Lastik olarak Kocaeli ve tüm ilçelerine kesintisiz <strong>acil lastik tamiri</strong>, <strong>lastik değişimi</strong> ve <strong>mobil lastikçi</strong> hizmeti sunuyoruz. Lastiğiniz patladı, sibobunuz arızalandı ya da yolda kaldınız mı? Bizi arayın, ortalama 30 dakikada yanınızdayız.
            </p>

            <h3>En Yakın Lastikçi Hizmeti — Kocaeli Geneli</h3>
            <p>
              <strong>En yakın lastikçi</strong> arayışınızda 7/24 Lastik size en hızlı çözümü sunar. <strong>İzmit lastikçi</strong>, <strong>Gebze lastik değişimi</strong>, <strong>Körfez lastikçi</strong>, <strong>Darıca lastikçi</strong>, <strong>Derince lastikçi</strong>, <strong>Gölcük lastikçi</strong> ve <strong>Kartepe lastikçi</strong> hizmetlerimiz ile Kocaeli'nin her noktasına mobil aracımızla geliyoruz.
            </p>

            <h3>7/24 Oto Lastik Yol Yardım</h3>
            <p>
              <strong>Oto lastik yol yardım</strong> ekibimiz günün her saati aktiftir. Gece yarısı, hafta sonu, bayram — fark etmez. <strong>Acil lastik yol yardım</strong> hizmetimiz ile TEM Otoyolu, D-100 Karayolu ve şehir içi yollarda lastik arızasına anında müdahale ediyoruz. <strong>Lastikçi ara</strong> ve dakikalar içinde ekibimizi yönlendirelim.
            </p>

            <h3>Hizmet Verdiğimiz Bölgeler</h3>
            <p>
              <Link to="/izmit-lastik-yol-yardim"><strong>İzmit</strong></Link>,{' '}
              <Link to="/gebze-lastik-yol-yardim"><strong>Gebze</strong></Link>,{' '}
              <Link to="/darica-lastik-yol-yardim"><strong>Darıca</strong></Link>,{' '}
              <Link to="/korfez-lastik-yol-yardim"><strong>Körfez</strong></Link>,{' '}
              <Link to="/golcuk-lastik-yol-yardim"><strong>Gölcük</strong></Link>,{' '}
              <Link to="/derince-lastik-yol-yardim"><strong>Derince</strong></Link>,{' '}
              <Link to="/cayirova-lastik-yol-yardim"><strong>Çayırova</strong></Link>,{' '}
              <Link to="/kartepe-lastik-yol-yardim"><strong>Kartepe</strong></Link>,{' '}
              <Link to="/basiskele-lastik-yol-yardim"><strong>Başiskele</strong></Link>,{' '}
              <Link to="/karamursel-lastik-yol-yardim"><strong>Karamürsel</strong></Link>,{' '}
              <Link to="/kandira-lastik-yol-yardim"><strong>Kandıra</strong></Link>,{' '}
              <Link to="/dilovasi-lastik-yol-yardim"><strong>Dilovası</strong></Link> ve{' '}
              <Link to="/hereke-lastik-yol-yardim"><strong>Hereke</strong></Link>{' '}
              bölgelerine <strong>mobil lastik yol yardım</strong> hizmeti vermekteyiz.
            </p>

            <h3>Neden 7/24 Lastik?</h3>
            <ul>
              <li><strong>Kocaeli lastik yol yardım</strong> konusunda 10+ yıllık tecrübe</li>
              <li><strong>7/24</strong> kesintisiz hizmet — gece, gündüz, bayram dahil</li>
              <li>Ortalama <strong>30 dakika</strong> müdahale süresi</li>
              <li><strong>24 ay garanti</strong> tüm işlemlerde</li>
              <li>Goodyear, Michelin, Bridgestone, Lassa, Pirelli gibi <strong>tüm markalar</strong> stokta</li>
              <li><strong>Lastik tamiri</strong>, <strong>lastik değişimi</strong>, sibop, jant, zincir takma</li>
              <li>Binek, kamyon, ticari araç — her araca hizmet</li>
            </ul>

            <p>
              <strong>Kocaeli lastikçi</strong> arayışınızda en hızlı ve güvenilir çözüm için bizi arayın. <strong>Lastik yol yardım</strong> hizmetimiz ile sizi yolda bırakmıyoruz. Profesyonel ekibimiz, kaliteli malzeme ve uygun fiyat garantisi ile Kocaeli'nin 1 numaralı <strong>mobil lastikçi</strong> firmasıyız.
            </p>
          </div>
        </motion.div>
      </div>

      <style>{`
        .seo-text h3 { font-family: 'Space Grotesk', sans-serif; font-weight: 700; font-size: 1.1rem; color: var(--text); margin: 1.75rem 0 .5rem; }
        .seo-text p { margin-bottom: 1rem; }
        .seo-text strong { color: var(--text); font-weight: 600; }
        .seo-text a { color: var(--blue); text-decoration: none; transition: opacity .2s; }
        .seo-text a:hover { opacity: .8; text-decoration: underline; }
        .seo-text ul { padding-left: 1.5rem; margin-bottom: 1.25rem; }
        .seo-text li { margin-bottom: .4rem; }
        .seo-text li::marker { color: var(--green); }
      `}</style>
    </section>
  );
}
